import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './SettingsModal.module.css';

// Assume a Firestore context for persistence exists.
// For now, this is a mock implementation.
const useFirestore = () => {
  const [settings, setSettings] = useState({});
  const saveSettings = (newSettings) => {
    console.log('Saving settings to Firestore:', newSettings);
    // Replace this with actual Firestore logic
    return new Promise(resolve => {
      setTimeout(() => {
        setSettings(newSettings);
        resolve();
      }, 500);
    });
  };
  const getSettings = () => {
    // Replace this with actual Firestore logic
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(settings);
      }, 500);
    });
  };

  return { settings, saveSettings, getSettings };
};

const SettingsModal = ({ show, onClose }) => {
  const { settings, saveSettings } = useFirestore();
  const [formParams, setFormParams] = useState(settings);
  const [status, setStatus] = useState('');

  useEffect(() => {
    if (show) {
      setFormParams(settings);
    }
  }, [show, settings]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormParams(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setStatus('Saving...');
    try {
      await saveSettings(formParams);
      setStatus('Settings saved successfully!');
    } catch (error) {
      setStatus(`Error saving settings: ${error.message}`);
    }
  };

  if (!show) {
    return null;
  }

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose}>&times;</button>
        <h2>Default Backtest Settings</h2>
        <form onSubmit={handleSave} className={styles.settingsForm}>
          <div className={styles.formGroup}>
            <label htmlFor="custom_tickers">Default Tickers</label>
            <input
              type="text"
              name="custom_tickers"
              value={formParams.custom_tickers || ''}
              onChange={handleInputChange}
            />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="start_date">Default Start Date</label>
            <input
              type="date"
              name="start_date"
              value={formParams.start_date || ''}
              onChange={handleInputChange}
            />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="end_date">Default End Date</label>
            <input
              type="date"
              name="end_date"
              value={formParams.end_date || ''}
              onChange={handleInputChange}
            />
          </div>
          <button type="submit" className={styles.saveButton}>Save Settings</button>
        </form>
        {status && <p className={styles.statusMessage}>{status}</p>}
      </div>
    </div>
  );
};

SettingsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SettingsModal;